
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { ReportHistoryOVO } from '@/views/biz/omr/vo/Omr.vo'
import Constants from '@/constants'
import CommonUtils from '@/common-utils'
import axios from 'axios'

@Component
export default class ReportHistoryComponent extends Vue {
  @Prop() emExam !: string;
  @Prop() smNo !: string;
  @Prop() emYear !: string;
  @Prop() excludeSubject !: string;

  reportHistoryList: Array<ReportHistoryOVO> = [];

  created(): void {
    const param: CommonSearchIVO = {} as CommonSearchIVO;
    param.emExam = this.emExam;
    param.smNo = this.smNo;
    param.emYear = this.emYear;

    // 최근 채점 이력
    axios.get(`omr/report-history`, {params: param})
    .then(r=>{
      this.reportHistoryList = r.data;

      this.$emit('update:gradeHistoryCount', r.data.length)
    })
  }
}
